import roundTo from 'round-to'

const celsiusToFahrenheit = (celsius, round=1) => {
  return roundTo((celsius * 9 / 5) + 32, round);
}

export default celsiusToFahrenheit;
